import React from "react"

import DocPageMoreButton from "./more/more-button"
import DocumentPage from "../../../../../../core/model2/doc/pages/page"

type Props = {
    data                    : DocumentPage

    selected                : boolean
    disabled                : boolean

    dndIsDragged?           : boolean
    dndIsDragInProgress?    : boolean
    isMouseEntered?         : boolean
    dndPreview?             : boolean

    onClick                 : {(data: DocumentPage): void}
    onDelete                : {(data: DocumentPage): void}
}

export default function DocPageItem(props: Props) {

    const classes = Classes('item page-item js-hover', {
        selected    : props.selected,
        'is-dragged': props.dndIsDragged,
        'is-hover'  : !props.dndIsDragInProgress && props.isMouseEntered,
        'is-preview': props.dndPreview
    })

    const onClick = () => {props.onClick(props.data)}
    const onDelete = () => {props.onDelete(props.data)}

    return (
        <div className={classes} onClick={onClick}>
            <div className="drag-icon i5-dnd"/>
            <div className="row">
                <div className="icon i5-file"/>
                <div className="name">{props.data.title}</div>
                {!props.disabled && <DocPageMoreButton onDelete={onDelete}/>}
            </div>
        </div>
    )
}